import { graphql, useStaticQuery } from "gatsby";
import React from "react";
import Link from "../../../utils/link";

const groupArrayIntoPairs = (array) => {
    const groups = [];
    
    for (let i = 0; i < array.length; i += 2) {
      groups.push(array.slice(i, i + 2));
    }
    
    return groups;
};
  

const ServicesHeader = (props) => {


    const servicePages = useStaticQuery(graphql`
        query ServicePages{
            posts: allStoryblokEntry(filter: {full_slug: {glob: "services/*"}}) {
                edges {
                node {
                    full_slug
                    name
                }
                }
            }           
        }
    `)

    // flatten the data

    const servicePagesArray = servicePages.posts.edges.map((edge) => {
        return edge.node;
    })


    // fake service array

    const servicePagesArrayFake = [
        {
            full_slug: "services/brand-strategy",
            name: "Brand Strategy"
        },
        {
            full_slug: "services/brand-voice",
            name: "Brand Voice"
        },
        {
            full_slug: "services/visual-identity-graphic-design",
            name: "Visual Identity & Graphic Design"
        },
        {
            full_slug: "services/packaging-design-copywriting",
            name: "Packaging Design"
        },
        {   
            full_slug: "services/website-design-copywriting",
            name: "Website Design"
        },
        {
            full_slug: "services/social-media-strategy",
            name: "Social Media"
        },
        {
            full_slug: "services/advertising-campaigns",
            name: "Campaigns & Advertising"
        },
        {
            full_slug: "services/content-writing",
            name: "Content Writing"
        },
        {
            full_slug: "services/naming",
            name: "Naming"
        },
        {
            full_slug: "services/signage-wayfinding",
            name: "Environments"
        }
    ]

    // group ever 2 services into a group

    const serviceGroups = groupArrayIntoPairs(servicePagesArrayFake)
        

    return (
        <nav className="absolute line-under-nav-height width pt-5 lg:pt-3 z-10 service-nav">
            <p className="lg:text-lg uppercase pb-4">
                Our services:
            </p>
            <ol className="flex lg:space-x-16 mobile:flex-col text-xs lg:text-sm space-y-2 lg:space-y-0 lg:hidden">
                {
                    serviceGroups.map((page, index) => {
                        const item1 = page[0]
                        const item2 = page[1]
                        return (
                            <li key={`service-header-${index}`} className="grid grid-cols-2 lg:flex lg:flex-col lg:space-y-2">
                                    <Link to={item1.full_slug} className={`${props.currentPage == item1.full_slug ? `active font-semibold` : ``}`}>{item1.name}</Link>
                                    {
                                        item2 != undefined && (
                                            <Link to={item2.full_slug} className={`${props.currentPage == item2.full_slug ? `active font-semibold` : ``}`}>{item2.name}</Link>
                                        )
                                    }

                            </li>
                        )
                    })
                }
            </ol>
            <ol className="grid grid-cols-5 mobile:hidden gap-y-2 gap-x-4">
                {
                    servicePagesArrayFake.map((page, index) => {
                        return (
                            <li key={`service-header-${index}-desk`} className="grid grid-cols-2 lg:flex lg:flex-col">
                                    <Link to={page.full_slug} className={`${props.currentPage == page.full_slug ? `active font-semibold` : ``}`}>{page.name}</Link>
                            </li>
                        )
                    })
                }
            </ol>

        </nav>
    )
}

export default ServicesHeader;